export default __webpack_public_path__ + "static/media/intro-copy-1.9dac5290.png";